import React, { } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide} from "swiper/react";
import './slideshow.css'

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import mm2pic from '../components/posts/25-26/pictures/MM2.jpeg';
import tradedesk from '../components/posts/25-26/pictures/tradedesk.jpeg';
import mm1pic from '../components/posts/25-26/pictures/MM1.jpeg';
import officerTeam from '../components/posts/25-26/pictures/friendsgiving/wicOfficerTeam.jpeg';
import friendsgiving1 from '../components/posts/25-26/pictures/friendsgiving/attendees1.jpeg';
import friendsgiving2 from '../components/posts/25-26/pictures/friendsgiving/attendees5.jpeg';
// import ghc3 from '../components/posts/23-24/pictures/ghc3.jpg';
// import ghc1 from '../components/posts/23-24/pictures/ghc1.jpg';
// import uberpic from '../components/posts/23-24/pictures/uberpic.jpg';
// import googlepic from '../components/posts/23-24/pictures/googlepic.jpg';


// import required modules
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper";

const Slideshow = () => {

  const images = [mm2pic, tradedesk, officerTeam, mm1pic, friendsgiving1, friendsgiving2];


  return (
    <>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        loopedSlides={images.length}
        initialSlide={0}
        onSwiper={(swiper) => { if (swiper && typeof swiper.slideToLoop === 'function') swiper.slideToLoop(0, 0); }}
        // effect="fade"
        // fadeEffect={{
        //   crossFade: true // enables slides to cross fade
        // }}
        speed={1200}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        loop={true}
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        className="mySwiper"
      >
        {images.map((img) => (
          <SwiperSlide className="slide" key={img}><img src={img} alt='wic'/></SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default Slideshow